import { useAccountRepository } from '@frontend/repository';
import { useState } from 'react';

import { useAppDispatch } from '../../../../redux/store';
import { UpdateGroupModalProps } from './update-group-modal.component';

export const useUpdateGroupModal = (props: UpdateGroupModalProps) => {
    const dispatch = useAppDispatch();
    const [userGroups, setUserGroups] = useState<string[]>(props.groups.map((g) => g.id));
    const { currentAccount } = useAccountRepository();

    return {
        dispatch,
        userGroups,
        setUserGroups,
        currentAccount
    };
};
